// client/src/coms/components/HostingSelector.js
// Where a new sticker or pack is stored: Local (default: this device, free, private) or Voxemera Server
// (online, shareable, Marketplace-ready). What the account may do comes from the server
// (GET /stickers/hosting, config/stickerHosting.js); this only displays it.
import React, { useEffect, useState } from 'react';
import { comsApiGet } from '../comsApi';

let cached = null;

export function useStickerHosting() {
  const [info, setInfo] = useState(cached);
  useEffect(() => {
    let alive = true;
    comsApiGet('/stickers/hosting')
      .then((r) => {
        cached = r;
        if (alive) setInfo(r);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return info;
}

const mb = (bytes) => `${(Number(bytes || 0) / (1024 * 1024)).toFixed(bytes > 10 * 1024 * 1024 ? 0 : 1)} MB`;

export default function HostingSelector({ value, onChange, name = 'hosting', disabled = false }) {
  const info = useStickerHosting();
  const caps = info && info.capabilities;
  const serverAllowed = !caps || caps.can_host_stickers_on_server;
  const option = (key, title, lines, allowed = true) => (
    <label className={`vox-hosting-option ${value === key ? 'selected' : ''} ${allowed ? '' : 'disabled'}`}>
      <input type="radio" name={name} value={key} checked={value === key} disabled={disabled || !allowed} onChange={() => onChange(key)} />
      <span>
        <span className="vox-hosting-title">{title}</span>
        {lines.map((line) => <span key={line} className="vox-hosting-line">{line}</span>)}
      </span>
    </label>
  );
  return (
    <fieldset className="vox-hosting" disabled={disabled}>
      <legend>Hosting</legend>
      {option('local', 'Local — Free', ['Stored on this device'])}
      {option(
        'server',
        'Voxemera Server',
        [
          'Stored online, shareable and marketplace ready',
          serverAllowed ? 'Currently free' : 'Not available on your account',
          ...(caps && info.usage && serverAllowed ? [`${mb(info.usage.bytes)} of ${mb(caps.server_sticker_storage_quota)} used · ${info.usage.packs}/${caps.server_sticker_pack_limit} packs`] : []),
        ],
        serverAllowed
      )}
    </fieldset>
  );
}
